export const allFeaturesDateTimeFormats = {
  shortWeekday: {
    weekday: "short",
  },
};

export const allFeaturesNumberFormats = {};
